import React, { useState } from "react";
import AssesmentDetails from "../components/Programs/AssesmentDetails";
import Aside from "../modules/SideNav/Aside";

function AssesmentDetailsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <AssesmentDetails handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default AssesmentDetailsLayout;
